module.exports = __webpack_public_path__ + "img/HR.0cdbe58a.png";